import { Text } from "@react-three/drei";
import LightWithFade from "./LightWithFade";

function InfoPanel({ position = [0, 0, 0], title, content, variant = "default" }) {
  // Positions dynamiques selon le type de panneau
  const titlePosition = variant === "special" ? [0, 2, 0.01] : [0, 1.5, 0.01];
  const contentPosition = variant === "special" ? [0, 0.5, 0.01] : [0, 0.1, 0.01];

  return (
    <group position={position} rotation={[0, Math.PI, 0]}>
      {/* Lumière */}
      <LightWithFade
        type="rectArea"
        duration={5}
        finalIntensity={8}
        color="white"
        width={3}
        height={3}
        position={[0, 1.2, 1]}
        rotation={[-Math.PI / 4, 0, 0]}
        easing
      />

      {/* Panneau principal */}
      <mesh position={[0, 0.6, -0.1]} rotation={[0, Math.PI, 0]}>
        <boxGeometry args={[3, 3.3, 0.2]} />
        <meshStandardMaterial color={"#111111"} roughness={1} metalness={0.9} />
      </mesh>

      {/* Titre */}
      <Text
        position={titlePosition}
        maxWidth={2.5}
        fontSize={0.1}
        font="/fonts/Montserrat-Bold.ttf"
      >
        {title}
      </Text>

      {/* Contenu */}
      <Text
        position={contentPosition}
        maxWidth={2.5}
        fontSize={0.09}
        whiteSpace="pre-line"
        font="/fonts/Montserrat-Regular.ttf"
      >
        {content}
      </Text>

      {/* Base */}
      <mesh position={[0, -1.5, 0]}>
        <boxGeometry args={[3.5, 0.25, 0.5]} />
        <meshStandardMaterial color={"#111111"} roughness={1} metalness={0.9} />
      </mesh>
    </group>
  );
}

export default InfoPanel;
